import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import ComparisonCard from './comparisonCard';
import Slider from 'react-slick';

const AtAGlanceComparison = () => {
  const data = imageQuery();

  const settingsComparisonCard = {
    dots: false,
    infinite: true,
    speed: 500,
    rows: 1,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          infinite: true,
          speed: 500,
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          className: 'center',
          centerPadding: '20px',
          centerMode: true,
        },
      },
    ],
  };

  return (
    <div className="location-comparison-container">
      <h4 className="col-md-12 text-center location-comparison-header">
        At-a-glance comparison
      </h4>
      <div className="">
        <Slider {...settingsComparisonCard}>
          <ComparisonCard
            isGold
            src={data.Fttp}
            title="FTTP"
            subtitle="full fibre"
            lineType="Fibre-optic cables all the way from the exchange into your home"
            speeds="Up to 1,000Mb"
            reliability="Rock solid"
          />
          <ComparisonCard
            src={data.Fttc}
            title="FTTC"
            subtitle="“partial” fibre"
            lineType="Fibre to the cabinet in the street, with analogue copper lines to your home"
            speeds="Up to 80Mb (if you’re lucky)"
            reliability="Inconsistent"
          />
          <ComparisonCard
            src={data.Adsl}
            title="ADSL"
            lineType="Analogue copper lines"
            speeds="Up to 17Mb"
            reliability="Poor"
          />
        </Slider>
      </div>
    </div>
  )
}

export default AtAGlanceComparison;

const imageQuery = () =>
  useStaticQuery(graphql`
  {
    Adsl: file(relativePath: { eq: "location-images/icons/ADSL.svg" }) {
      name
      relativePath
      extension
      publicURL
    }
    Fttc: file(relativePath: { eq: "location-images/icons/FTTC.svg" }) {
      name
      relativePath
      extension
      publicURL
    }
    Fttp: file(relativePath: { eq: "location-images/icons/FTTP.svg" }) {
      name
      relativePath
      extension
      publicURL
    }
  }
`)